const API_BASE_URL = "https://sandbox.easyapp.app.br/primusimport/api/v1";
//const API_BASE_URL = "http://localhost:8000/v1";
//const API_BASE_URL = "http://192.168.3.5:8000/v1";

const fetchAPI = async (endpoint, options = {}) => {
    // Monta a URL completa
    const url = `${API_BASE_URL}${endpoint}`;
    const defaultHeaders = {
        "Content-Type": "application/json",
        "Application-Token": "7683c1e3-2eeb-4a0b-b06b-42b4aae13788",
    };

    // Adiciona o token de autenticação, se existir
    const auth = JSON.parse(localStorage.getItem("auth"));
    if (auth) {
        defaultHeaders["Authentication-Token"] = auth.token;
    }

    // Combina as opções padrão com as opções recebidas
    const config = {
        ...options,
        headers: {
            ...defaultHeaders,
            ...options.headers,
        },
    };

    return new Promise(async (resolve, reject) => {
        try {
            // Faz a requisição
            const response = await fetch(url, config);

            switch (response.status) {
                case 204: // No Content
                    return resolve({
                        status: response.status,
                        body: null,
                    });
                case 401: // Unauthorized
                    // Se não estiver na página de login, redireciona
                    if (window.location.pathname !== "primusimport/login") {
                        window.location.href = "primusimport/login";
                    }
                    return reject({
                        status: 401,
                        body: { message: "Unauthorized" },
                    });
                default:
                    break;
            }

            const body = await response.json();
            
            // Retorna o status e o corpo da resposta
            resolve({
                status: response.status,
                body: body,
            });
        } catch (error) {
            reject({
                status: error.status || 500,
                body: error,
            });
        }
    });
};

/**
 * Fetches data from the specified API endpoint using a GET request.
 *
 * @async
 * @function
 * @param {string} endpoint - The API endpoint to fetch data from.
 * @returns {Promise<any>} The response from the API or an error object if the request fails.
 */
export const getData = async (endpoint) => {
    try {
        return await fetchAPI(endpoint, {
            method: "GET",
        });
    } catch (error) {
        return error;
    }
};

/**
 * Sends a POST request to the specified endpoint with the provided data.
 *
 * @async
 * @function
 * @param {string} endpoint - The API endpoint to send the request to.
 * @param {Object} data - The data to be sent in the request body.
 * @returns {Promise<any>} The response from the API or an error object if the request fails.
 */
export const postData = async (endpoint, data) => {
    try {
        return await fetchAPI(endpoint, {
            method: "POST",
            body: JSON.stringify(data),
        });
    } catch (error) {
        return error;
    }
};

/**
 * Sends a PUT request to the specified endpoint with the provided data.
 *
 * @async
 * @function
 * @param {string} endpoint - The API endpoint to send the request to.
 * @param {string|number|null} [id=null] - Optional ID to append to the endpoint URL.
 * @param {Object} data - The data to be sent in the request body.
 * @returns {Promise<any>} The response from the API or an error object if the request fails.
 */
export const putData = async (endpoint, id = null, data) => {
    try {
        // Verifica se o ID foi passado
        if (id) {
            endpoint = `${endpoint}/${id}`; // Inclui o ID na URL
        }

        return await fetchAPI(endpoint, {
            method: "PUT",
            body: JSON.stringify(data),
        });
    } catch (error) {
        return error;
    }
};

/**
 * Sends a DELETE request to the specified endpoint, optionally including an ID.
 *
 * @async
 * @function
 * @param {string} endpoint - The API endpoint to send the DELETE request to.
 * @param {string|number|null} [id=null] - Optional ID to append to the endpoint URL.
 * @returns {Promise<any>} The response from the API or an error object if the request fails.
 */
export const deleteData = async (endpoint, id = null) => {
    try {
        // Verifica se o ID foi passado
        if (id) {
            endpoint = `${endpoint}/${id}`; // Inclui o ID na URL
        }

        // Realiza a requisição DELETE
        return await fetchAPI(endpoint, {
            method: "DELETE",
        });
    } catch (error) {
        return error;
    }
};
